var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { UndoableAction, UserEdit } from "Server/CommandMacros";
import { Command, AssertV, AssertValidate } from "mobx-firelink";
import { GenerateUUID } from "Utils/General/KeyGenerator";
const MTName = "MapObject";
let AddMapObject = class AddMapObject extends Command {
    Validate() {
        const { object } = this.payload;
        AssertValidate({
            properties: {
                object: { $ref: MTName },
                parent: { $ref: "UUID" },
            },
            required: ["object", "parent"],
        }, this.payload, "Payload invalid");
        AssertV(object.parent == null, "payload.object.parent must be null. (use payload.parent instead)");
        this.id = GenerateUUID();
        this.returnData = this.id;
    }
    GetDBUpdates() {
        const { object, parentID } = this.payload;
        const updates = {};
        // add object
        updates[`general/data/.last${MTName}ID`] = this.id;
        updates[`mapObjects/${this.id}`] = object;
        // connect parent and child
        if (parentID) {
            //object.parents = {[parent]: true};
            object.parent = parentID;
            updates[`mapObjects/${parentID}/.children/.${this.id}`] = true;
        }
        return updates;
    }
};
AddMapObject = __decorate([
    UserEdit,
    UndoableAction()
], AddMapObject);
export { AddMapObject };
